// 项目全局所需配置项
// 判断是否是正式环境
export var baseUrl = (location.host.includes("yxt.qytyw.com") || location.host.includes("yxt.qyclw.cn") || location.host.includes("xnhtf.xnhkfpt.com")) ? "https://yxt.qytyw.com" : "https://yxt.qwqycl.com";

export var apiBaseUrl = (location.host.includes("yxt.qytyw.com") || location.host.includes("yxt.qyclw.cn") || location.host.includes("xnhtf.xnhkfpt.com")) ? "https://yxtapi.qytyw.com/apipost" : "https://yxtapi.qwqycl.com/apipost";
// export var apiBaseUrl = (location.host.includes("yxt.qytyw.com") || location.host.includes("yxt.qyclw.cn") || location.host.includes("xnhtf.xnhkfpt.com")) ? "https://yxtapi.qytyw.com/apipost" : "https://yxtapi.qytyw.com/apipost";

export var apiBaseUrlForXnh = (location.host.includes("yxt.qytyw.com") || location.host.includes("yxt.qyclw.cn") || location.host.includes("xnhtf.xnhkfpt.com")) ? "https://apixnh.xnhkfpt.com/api" : "https://xnhloc.xnhkfpt.com/api";

// 视宣号定制版的接口地址
export var apiBaseUrlForComplex = (location.host.includes("yxt.qytyw.com") || location.host.includes("yxt.qyclw.cn") || location.host.includes("xnhtf.xnhkfpt.com")) ? "//yxt.qytyw.com/xnh/xnhapi" : "//yxt.qwqycl.com/xnh/xnhapi";

// 视宣号定制版的文件地址
export var baseUrlForComplex = (location.host.includes("yxt.qytyw.com") || location.host.includes("yxt.qyclw.cn") || location.host.includes("xnhtf.xnhkfpt.com")) ? "https://xnh.xnhkfpt.com/static/vueVideoMake/" : "https://xnhloc.xnhkfpt.com/qudao/static/vueVideoMake/";

export var sourceurl = "https://static.xnhkfpt.com/xnhdouyin/source/";

export var sourceurlXnh = "https://img.xnhkfpt.com/lvdata/vedio/uploadFiles/xnhQudaoMain/yxtAddprice/";

export var xnhDESKey = "xnh20241023qwe";
export var xnhAccessKey = "8cxnhpro38efd2a3c74fds4seg3ef8iop";
export var xnhSecretKey = "22887923b-89bc-5432-xcff-1878231dy4578";

// 接口请求类似于账号密码 2024/04/12改为由VUEX管理
// export var appkeyValue = "zhufeng666";
// export var appSecretKeyValue = "zhufeng!@#xCzG";
// 长沙凯萨
// export var appkeyValue = "csks";
// export var appSecretKeyValue = "csksD6xDA1G";

// 获取浏览器类型
export function getBrowserType() {
  var userAgent = navigator.userAgent; // 取得浏览器的userAgent字符串
  var browser = "unknown";
  if (userAgent.indexOf("IE") != -1) {
    browser = "IE";
  } else if (userAgent.indexOf("Firefox") != -1) {
    browser = "Firefox";
  } else if (userAgent.indexOf("OPR") != -1) {
    browser = "Opera";
  } else if (userAgent.indexOf("Chrome") != -1) {
    browser = "Chrome";
  } else if (userAgent.indexOf("Safari") != -1) {
    browser = "Safari";
  } else if (userAgent.indexOf("Trident") != -1) {
    browser = "IE 11";
  }
  return browser;
}

/**
 * 判断当前的环境是否在 微信环境下
 * */
export function isWeiXin() {
  var ua = window.navigator.userAgent.toLowerCase();
  if (ua.match(/MicroMessenger/i) == "micromessenger") {
    return true;
  } else {
    return false;
  }
}

/**
 * 判断当前的设备是ios还是安卓
 * */
export function systemType() {
  var u = navigator.userAgent;
  var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; // 判断是否是安卓
  var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); // 判断是否是 iOS
  if (isAndroid) {
    return "Android";
  } else if (isiOS) {
    return "ios";
  } else {
    return "unknown";
  }
}




// WEBPACK FOOTER //
// ./src/utils/common.js